import cn from 'clsx'
import {Checkbox, Spin} from 'antd'

import styles from './MilestoneAction.module.scss'
import {ArrowIcon} from 'common/components'
import {getMilestone, getNameOfRequestMilestone, RequestMilestone, RequestTagType} from '..'
import { RequestMilestone as VariationRequestMilestone } from '../types.variation'

interface MilestoneActionProps {
  tag?: RequestTagType
  type: RequestMilestone | VariationRequestMilestone
  milestones: any[]
  disableChecked?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  onArrowClick?: () => void
}

export default function MilestoneAction({
  tag,
  type,
  milestones,
  disableChecked,
  loading,
  disabled,
  onClick,
  onArrowClick,
}: MilestoneActionProps) {
  const milestone = getMilestone(type, milestones)

  const checked = milestone ? milestone.passed : false
  const isNotActive =
    loading || (checked && (disableChecked || loading !== undefined))
  const showArrow = !disabled && !isNotActive && loading === undefined

  const handleArrowClick = (e:any) => {
    e.stopPropagation()
    e.preventDefault()
    onArrowClick?.()
  }
  return (
    <div className={cn(styles.root, isNotActive && styles.root_notActive)}>
      <Checkbox
        checked={checked}
        className={cn(styles.check, loading && styles.check_loading)}
        disabled={disabled}
        onClick={isNotActive ? undefined : onClick}
      >
        {getNameOfRequestMilestone(type, tag)}
        { (showArrow || !!onArrowClick) && (
          <ArrowIcon className={styles.icon} width={11} height="100%" 
            onClick={!onArrowClick ? undefined : handleArrowClick}
          />
        )}
        {loading && <Spin className={styles.spin} size="small" />}
      </Checkbox>
    </div>
  )
}
